var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeNotification)?_c('div',{staticClass:"pa-5"},[_c('v-row',[_c('v-col',{staticClass:"col-item row-title",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm._f("t")("ID")))]),_c('v-col',{staticClass:"col-item",attrs:{"cols":"6"}},[_vm._v(" "+_vm._s(_vm.activeNotification.id ? _vm.activeNotification.id : "-")+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }